/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialCompanyDiscountUpdateRequest } from '../../models/editorial-company-discount-update-request';

export interface UpdateEditorialCompanyDiscount$Params {
  companyId: number;
  discountId: number;
      body: EditorialCompanyDiscountUpdateRequest
}

export function updateEditorialCompanyDiscount(http: HttpClient, rootUrl: string, params: UpdateEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateEditorialCompanyDiscount.PATH, 'put');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.path('discountId', params.discountId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateEditorialCompanyDiscount.PATH = '/api/editorial/companies/{companyId}/discounts/{discountId}';
